import './ServerDocTranslationMessage.scss'

import React from 'react'

import { Box } from '@/components/ui/box'
import { Container } from '@/components/ui/container'
import { Text } from '@/components/ui/typography'
import { IShortMessageObject } from '@/types/gigiChat/Chat'

import ErrorMessage from '../serverMessage/ErrorMessage'
import TypingDots from '../typingDots/TypingDots'
import AnswerDocTranslationMarkdown from './components/answerDocTranslationMarkdown'

const ServerDocTranslationMessage = React.memo(
    ({
        item,
        isLastItem,
        question,
        answer,
    }: {
        item: IShortMessageObject
        isLastItem: boolean
        question: string
        answer: string | null
    }) => {
        const getTranslationLanguages = () => {
            let languageNames: string[] = []
            if (item.structuredAnswer?.docTranslate) {
                languageNames = item.structuredAnswer?.docTranslate?.languages
                    .map((lang) => lang.languageEnglishName)
                    .filter((name) => name !== undefined)
            }
            return `Translate to: ${languageNames.join(', ')}`
        }

        const getQuestion = () => {
            if (item.structuredAnswer?.docTranslate) {
                return (
                    <>
                        <Box mb="8px">{getTranslationLanguages()}</Box>
                        {item.structuredAnswer?.docTranslate?.documents.map((doc, index) => {
                            return <Box key={doc.documentName + index}>{doc.documentName}</Box>
                        })}
                    </>
                )
            }
            return null
        }

        return (
            <>
                <Container my="1" maxWidth="unset" variant="user">
                    <Text className="ServerTextTranslationMessage" lineHeight="20px" fontSize="14px" as="div" overflowX="auto">
                        {getQuestion() || question}
                    </Text>
                </Container>
                {item.structuredAnswer && item.structuredAnswer?.docTranslate && !item.instructionalErrorMessageId && (
                    <Container
                        variant="server"
                        mt="1"
                        maxWidth="unset"
                        borderRadius={item.citations && item.citations.length > 0 ? '' : '4px'}
                        borderTopRadius={item.citations && item.citations.length > 0 ? '4px' : ''}
                        id={item.userPromptId?.toString()}
                        display={item.isStreaming ? 'none' : 'block'}
                    >
                        <AnswerDocTranslationMarkdown res={item.structuredAnswer?.docTranslate} userPromptId={item.userPromptId} />
                    </Container>
                )}
                {!item.structuredAnswer && !item.instructionalErrorMessageId && answer && (
                    <Container
                        variant="server"
                        mt="1px"
                        maxWidth="unset"
                        id={item.userPromptId?.toString()}
                        display={item.isStreaming ? 'none' : 'block'}
                    >
                        <ErrorMessage message={answer} />
                    </Container>
                )}

                {answer && !item.isStreaming && item.instructionalErrorMessageId && <ErrorMessage message={answer} />}
                {/* {!answer && !item.isStreaming && <ErrorMessage />} */}
                {item.isStreaming && isLastItem && <TypingDots />}
            </>
        )
    },
)

export default ServerDocTranslationMessage
